import script from "./ Infocenter.vue?vue&type=script&setup=true&lang=js"
export * from "./ Infocenter.vue?vue&type=script&setup=true&lang=js"

import "./ Infocenter.vue?vue&type=style&index=0&id=ffd4be68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd4be68"]])

export default __exports__